const defaultMonthOptions = {
    default: {
        // December
        month: "long",
    },
};
export { defaultMonthOptions };
